import type { AxiosResponse } from 'axios';
import type { Certification } from '@app-types/models/certification';
import api from './api';

interface CertificationsResponse {
  certifications: Certification[];
  [key: string]: unknown;
}

export const getCertifications = async (): Promise<CertificationsResponse> => {
  try {
    const response: AxiosResponse<CertificationsResponse> = await api.get('/business/certifications');
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching certifications:', error);
    throw error;
  }
};
